export class LanguageService {
  constructor ($log, $translate) {
    'ngInject';
    this.$translate = $translate;
    this.$log = $log;
  }

  getLanguages () {
    return [{
      id: "pl_PL",
      name: "Polski"
    }, {
      id: "en_US",
      name: "English"
    }];
  }

  currentLanguage() {
    return localStorage.getItem("roedl-language");
  }

  changeLanguage(language) {
    this.$log.info(`Changed language to ${language}`);
    this.$translate.use(language);
    localStorage.setItem("roedl-language", language);
    window.dispatchEvent(new Event("storage"));
  }
}
